<cmp-html-container [id]="widgetDescriptor.WidgetID" [data]="(widgetData)?widgetData.HtmlData:null" [statusZoom]="false" [widget]="widgetDescriptor" ></cmp-html-container>
